module.exports = __webpack_public_path__ + "static/img/1.1e54a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/1.png
// module id = UlF2
// module chunks = 0